import React, { useEffect, useState } from "react";
import "./AgentRuntime.scss";
import {
  IAgentRuntime,
  IAgentWorkflow,
} from "../../../../models/AgentRuntime.model";
import AgentRun from "./AgentWorkFlow/AgentRun/AgentRun";
import WorkflowTable from "./AgentWorkFlow/WorkflowTable/WorkflowTable";
import { FakeAgentRuntime } from "../../../../fakeStorage/teams/AgentRuntime";
import TeamRun from "./AgentWorkFlow/WorkflowTable/TeamRun/TeamRun";
import { IAgent } from "../../../../models/Agent.model";
import { Utils } from "../../../../utils/Utils";

export default function AgentRuntime({
  selectedTeam,
  setShowRunTime,
}: {
  selectedTeam: {
    name: string;
    agents: IAgent[];
  };
  setShowRunTime: any;
}) {
  const [selectedWorkflowName, setSelectedWorkflowName] = useState("");
  const [agentRun, setAgentRun] = useState<IAgentRuntime>(FakeAgentRuntime[0]);
  const [activeRunId, setActiveRunId] = useState<string>("");
  const [selectedWorkflow, setSelectedWorkflow] = useState<IAgentWorkflow[]>(
    []
  );
  const [isNewRunOpen, setIsNewRunOpen] = useState(false);
  const [selectedConfigId, setSelectedConfigId] = useState("");

  const handleWorkflowSelection = (configId: string) => {
    setSelectedConfigId(configId);
    setIsNewRunOpen(true);
  };

  useEffect(() => {
    const selectedAgentRun =
      FakeAgentRuntime.find((run) => run.label === selectedTeam.name) ||
      FakeAgentRuntime[0];
    setAgentRun({
      ...selectedAgentRun,
      label: selectedTeam.name,
      workflow: selectedTeam.agents.map((agent, i) => {
        const selectedWrkflow = selectedAgentRun.workflow.find(
          (wflow) => wflow.tabName === agent.name
        );
        if (selectedWrkflow) {
          return selectedWrkflow;
        }
        return { ...selectedAgentRun.workflow[i], tabName: agent.name };
      }),
      historyRuns: FakeAgentRuntime.some((run) => run.label === selectedTeam.name) ? selectedAgentRun?.historyRuns : [],
    });
  }, [selectedTeam]);

  const handleBack = () => {
    setSelectedWorkflowName("");
    setSelectedWorkflow([]);
  };

  const handleUpdateRun = ({
    tokensUsed,
    score,
  }: {
    tokensUsed: string;
    score: number;
  }) => {
    setAgentRun({
      ...agentRun,
      historyRuns: agentRun.historyRuns.map((run) => {
        if (run.runId === activeRunId) {
          return { ...run, status: "success", tokensUsed, score };
        }
        return run;
      }),
    });
  };

  const handleRunClick = (runId: string) => {
    setActiveRunId(runId);
    setSelectedWorkflowName(agentRun.label);
    setSelectedWorkflow(agentRun?.workflow);
  };

  const handleRunTeam = () => {
    setIsNewRunOpen(false);
    const historyCounts = agentRun?.historyRuns?.length || 0;
    const newRunId = "PAIWF-0804192" + historyCounts + 1;
    setActiveRunId(newRunId);
    const historyRun = Utils.deepClone(agentRun.historyRuns);
    historyRun.push({
      configId: selectedConfigId
        ? selectedConfigId
        : "CONF-000001" + historyCounts + 1,
      runId: newRunId,
      status: "inProgress",
      runDateTime: new Date().toISOString(),
      tokensUsed: "",
      score: 0,
    });
    setAgentRun({ ...agentRun, historyRuns: historyRun });
    setTimeout(() => {
      setSelectedWorkflowName(agentRun?.label);
      setSelectedWorkflow(agentRun?.workflow);
    }, 1000);
  };

  return (
    <div className="agent-runtime">
      {!selectedWorkflowName && (
        <WorkflowTable
          handleBack={() => setShowRunTime(false)}
          agentRun={agentRun}
          handleRunClick={handleRunClick}
          handleStartWorkflow={handleWorkflowSelection}
        />
      )}
      {selectedWorkflowName && selectedWorkflow.length > 0 && (
        <AgentRun
          handleBack={handleBack}
          handleUpdateRun={handleUpdateRun}
          selectedWorkflow={selectedWorkflowName}
          workflows={selectedWorkflow}
        />
      )}
      {isNewRunOpen && (
        <TeamRun
          selectedTeam={selectedTeam}
          setIsNewRunOpen={setIsNewRunOpen}
          handleRunTeam={handleRunTeam}
        />
      )}
    </div>
  );
}
